import type { ChartPalette, ChartDataRecord } from "../types/reports.types";

export const chartPalette: ChartPalette = {
  blue:      "#14508c",
  blueLight: "#4a80b8",
  blueSoft:  "#e6f0f8",
  teal:      "#0f6b6b",
  green:     "#1a6b35",
  amber:     "#d97706",
  red:       "#a32d2d",
  purple:    "#5b21b6",
  gray:      "#909399",
};

export const chartData: ChartDataRecord = {
  projectMixShare: [
    { name: "Residential", value: 60 },
    { name: "Commercial",  value: 40 },
  ],
  monthlyNewProjects: [
    { name: "Jul", value: 3 },
    { name: "Aug", value: 2 },
    { name: "Sep", value: 4 },
    { name: "Oct", value: 3 },
    { name: "Nov", value: 2 },
    { name: "Dec", value: 1 },
    { name: "Jan", value: 4 },
    { name: "Feb", value: 3 },
    { name: "Mar", value: 3 },
    { name: "Apr", value: 4 },
    { name: "May", value: 2 },
    { name: "Jun", value: 3 },
  ],
  projectsByBank: [
    { name: "Kennebunk Savings",  value: 12 },
    { name: "Androscoggin Bank",  value: 10 },
    { name: "TD Bank",            value: 8  },
    { name: "Camden National",    value: 6  },
    { name: "Bangor Savings",     value: 4  },
  ],
  contractValueDistribution: [
    { name: "< $250K",      value: 4  },
    { name: "$250K-$500K",  value: 9  },
    { name: "$500K-$1.5M",  value: 21 },
    { name: "$1.5M-$3M",    value: 8  },
    { name: "$3M-$5M",      value: 3  },
    { name: "> $5M",        value: 2  },
  ],
  drawVolumeAndFlags: [
    { name: "Jul", draws: 12, flagRate: 14 },
    { name: "Aug", draws: 11, flagRate: 18 },
    { name: "Sep", draws: 14, flagRate: 16 },
    { name: "Oct", draws: 13, flagRate: 20 },
    { name: "Nov", draws: 10, flagRate: 12 },
    { name: "Dec", draws: 9,  flagRate: 10 },
    { name: "Jan", draws: 16, flagRate: 15 },
    { name: "Feb", draws: 15, flagRate: 18 },
    { name: "Mar", draws: 17, flagRate: 19 },
    { name: "Apr", draws: 18, flagRate: 16 },
    { name: "May", draws: 14, flagRate: 14 },
    { name: "Jun", draws: 15, flagRate: 17 },
  ],
  inspectionTurnaround: [
    { name: "Jul", value: 5.4 },
    { name: "Aug", value: 5.2 },
    { name: "Sep", value: 5.0 },
    { name: "Oct", value: 4.8 },
    { name: "Nov", value: 4.9 },
    { name: "Dec", value: 4.7 },
    { name: "Jan", value: 4.5 },
    { name: "Feb", value: 4.4 },
    { name: "Mar", value: 4.3 },
    { name: "Apr", value: 4.2 },
    { name: "May", value: 4.1 },
    { name: "Jun", value: 4.2 },
  ],
  cscFeeRevenue: [
    { name: "Jul", value: 6750  },
    { name: "Aug", value: 8625  },
    { name: "Sep", value: 7500  },
    { name: "Oct", value: 7125  },
    { name: "Nov", value: 3750  },
    { name: "Dec", value: 5625  },
    { name: "Jan", value: 10500 },
    { name: "Feb", value: 7875  },
    { name: "Mar", value: 8625  },
    { name: "Apr", value: 11250 },
    { name: "May", value: 7500  },
    { name: "Jun", value: 10125 },
  ],
  costPerSfTrend: [
    { name: "Jul", residential: 168, commercial: 238 },
    { name: "Aug", residential: 170, commercial: 240 },
    { name: "Sep", residential: 174, commercial: 245 },
    { name: "Oct", residential: 178, commercial: 248 },
    { name: "Nov", residential: 180, commercial: 252 },
    { name: "Dec", residential: 183, commercial: 256 },
    { name: "Jan", residential: 183, commercial: 256 },
    { name: "Feb", residential: 185, commercial: 258 },
    { name: "Mar", residential: 186, commercial: 260 },
    { name: "Apr", residential: 186, commercial: 262 },
    { name: "May", residential: 188, commercial: 264 },
    { name: "Jun", residential: 187, commercial: 264 },
  ],
  contingencyUtilization: [
    { name: "< $500K",   value: 72 },
    { name: "$500K-$1.5M", value: 61 },
    { name: "$1.5M-$3M",   value: 55 },
    { name: "$3M-$5M",     value: 48 },
    { name: "> $5M",       value: 42 },
  ],
  gcDrawAccuracy: [
    { name: "Reynolds Const.",    value: 96 },
    { name: "DeStefano & Assoc.", value: 94 },
    { name: "SNH Mechanical",     value: 95 },
    { name: "Northland GC",       value: 91 },
    { name: "BTB Build",          value: 88 },
  ],
  preconSubmissionTimes: [
    { name: "1-2d",  value: 28 },
    { name: "3-5d",  value: 42 },
    { name: "6-10d", value: 18 },
    { name: "11-20d", value: 8 },
    { name: "20d+",  value: 4  },
  ],
  waiversCollected: [
    { name: "Jul", value: 4  },
    { name: "Aug", value: 8  },
    { name: "Sep", value: 12 },
    { name: "Oct", value: 18 },
    { name: "Nov", value: 22 },
    { name: "Dec", value: 26 },
    { name: "Jan", value: 30 },
    { name: "Feb", value: 34 },
    { name: "Mar", value: 36 },
    { name: "Apr", value: 38 },
    { name: "May", value: 40 },
    { name: "Jun", value: 44 },
  ],
  signatureDistribution: [
    { name: "< 1hr",  value: 32 },
    { name: "1-4hr",  value: 28 },
    { name: "4-8hr",  value: 18 },
    { name: "8-24hr", value: 10 },
    { name: "1-2d",   value: 6  },
  ],
  userGrowthByRole: [
    { name: "Jul", gcOwner: 18, lender: 9,  cscTeam: 4, architect: 2 },
    { name: "Aug", gcOwner: 20, lender: 10, cscTeam: 4, architect: 2 },
    { name: "Sep", gcOwner: 22, lender: 11, cscTeam: 5, architect: 3 },
    { name: "Oct", gcOwner: 24, lender: 12, cscTeam: 5, architect: 3 },
    { name: "Nov", gcOwner: 26, lender: 13, cscTeam: 6, architect: 3 },
    { name: "Dec", gcOwner: 28, lender: 14, cscTeam: 6, architect: 3 },
    { name: "Jan", gcOwner: 30, lender: 15, cscTeam: 7, architect: 4 },
    { name: "Feb", gcOwner: 32, lender: 16, cscTeam: 7, architect: 4 },
    { name: "Mar", gcOwner: 34, lender: 17, cscTeam: 8, architect: 4 },
    { name: "Apr", gcOwner: 36, lender: 18, cscTeam: 8, architect: 4 },
    { name: "May", gcOwner: 38, lender: 19, cscTeam: 9, architect: 5 },
    { name: "Jun", gcOwner: 40, lender: 20, cscTeam: 9, architect: 5 },
  ],
  usersByRole: [
    { name: "GC",        value: 26 },
    { name: "Owner",     value: 12 },
    { name: "Lender",    value: 15 },
    { name: "CSC",       value: 8  },
    { name: "Architect", value: 4  },
  ],
  featureAdoption: [
    { name: "Mobile FI",          value: 69 },
    { name: "Digital Waivers",    value: 78 },
    { name: "Pre-con Checklist",  value: 94 },
    { name: "GC Draw Portal",     value: 82 },
  ],
  bankPartnerGrowth: [
    { name: "Jul", value: 5 },
    { name: "Aug", value: 5 },
    { name: "Sep", value: 6 },
    { name: "Oct", value: 6 },
    { name: "Nov", value: 6 },
    { name: "Dec", value: 7 },
    { name: "Jan", value: 7 },
    { name: "Feb", value: 7 },
    { name: "Mar", value: 8 },
    { name: "Apr", value: 8 },
    { name: "May", value: 9 },
    { name: "Jun", value: 9 },
  ],
};
